import React, { Component } from 'react';
import {actions, connect} from "@modules/wrap-redux/index";
import createMsg from "@modules/createMsg";
import Tags from "./userInput/Tags";
import { setlog } from '@modules/58m';
//wrap-redux
// WrapRedux.model({
//     name:"inputAreaData",
//     initialState:{
//         value:'',
//         tags:[],
//     },
//     reducers:{//参数1 state 参数2 action.data
//         changeInputValue(state,data){
//           return {
//             ...state,
//             value:data
//           }
//         },
//         refreshTag(state,data){
//           return {
//             ...state,
//             tags:data,
//           }
//         }
//     },
//     effects:{
//     }
// })

class InputArea extends Component {
    handleChange=(event)=>{
       actions.inputAreaData.changeInputValue({data:event.target.value});
    }
    handleSendBtn=()=>{
      let val = this.props.inputAreaData.value;
      val.trim&&(val = val.trim());
      if(val !== ""){
          //这时候算失去焦点 所以键盘收起 但是不发消息
          this._sendMsg({value:val});
      }
      actions.inputAreaData.changeInputValue({data:""});
    }
    handleKeyUp=(event)=>{
       //console.log("keyup",event.keyCode);
        if(event.keyCode === 13){
            setlog("mchatbot_infosend_click");
            let val = event.target.value;
            val.trim&&(val = val.trim());
            if(val === "") return;//这时候不让键盘收起来
            actions.inputAreaData.changeInputValue({data:""});
            document.querySelector('#userinput').blur();
            this._sendMsg({value:val});
        }
    }
    handleOnFocus=(event)=>{
        setlog("mchatbot_inputbox_click");
        //document.querySelector('.module-userinput').scrollIntoView(true);
        //scrollIntoView 无法保证不遮挡 尤其是切换语法的时候 因此采用定时器
        if(SYSTEM == "ios"){
        //this.dealInputInterval
            setTimeout(function(){
                window.scrollTo(0,document.body.offsetHeight);
                //document.body.scrollTop = document.body.scrollHeight;
            },800);
        }else{
            
        //    setInterval(function() {
        //       // alert(document.querySelector('#userinput').scrollIntoView)
        //     document.querySelector('#userinput').scrollIntoView()
        //     document.querySelector('#userinput').scrollIntoViewIfNeeded()
        //     }, 500)
            //document.querySelector('.module-userinput').classList.add('focus');
           // document.querySelector('.module-userinput').scrollIntoView(false);
        }

    
    }
    handleOnBlur=(event)=>{
        //clearInterval(this.dealInputInterval)
        this.dealInputInterval = setTimeout(function(){
            window.scrollTo(0,0);
            //document.body.scrollTop = document.body.scrollHeight;
        },0);
    }
    handleClickTag=(event)=>{
        setlog("mchatbot_hot_click");
        let label = event.currentTarget.getAttribute('data-label');
        let value = event.currentTarget.getAttribute('data-value');
        this._sendMsg({value,label});
    } 
    _sendMsg=(data)=>{
        let msg = createMsg(data);
        actions.chatAreaData.sendMsg({data:msg});
    }
    render() {
    const {value,tags} = this.props.inputAreaData;
    const isActiveInputSendBtn = (value===""?false:true);
    return (
        <div className="module-userinput">
          <div className="area-wrap">
            <Tags tags={tags} handleClickTag={this.handleClickTag}></Tags>
            <div className="input-area">
                <div className="input-wrap">
                    <span className="iconfont icon-input_robot_icx edit-icon"></span>
                    <input  type="text" id="userinput" placeholder="请输入..." 
                        onKeyUp={this.handleKeyUp} 
                        onFocus={this.handleOnFocus} 
                        onBlur = {this.handleOnBlur}
                        onChange = {this.handleChange}
                        value={value}  
                    />
                    <span className={isActiveInputSendBtn?"input-send-btn active":"input-send-btn"} id="input-send-btn" onClick={this.handleSendBtn}></span>
            </div>
            </div>
          </div>
        </div>

    );
  }
}

export default connect(state =>{
    return {
        inputAreaData:state.inputAreaData
    }
})(InputArea)
